import React from 'react';
import Paper from '@mui/material/Paper';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';

import { indigo, pink, teal, purple, deepOrange, yellow, blueGrey, brown } from '@mui/material/colors';

export default function Summary() {
    return <Paper elevation={3} className='section-container' id='skills'>
        <h2>Skills</h2>
        <Stack id='skills-stack' direction="row" spacing={1} style={{
            flexWrap: 'wrap',
            width: '100%',
        }}>
            <Chip label={'TypeScript'} style={{ backgroundColor: indigo[900] }} />
            <Chip label={'Python'} style={{ backgroundColor: indigo[900] }} />
            <Chip label={'SQL'} style={{ backgroundColor: indigo[900] }} />
            <Chip label={'C++'} style={{ backgroundColor: indigo[900] }} />
            <Chip label={'C#'} style={{ backgroundColor: indigo[900] }} />
            <Chip label={'Rust'} style={{ backgroundColor: indigo[900] }} />
            <Chip label={'Dart'} style={{ backgroundColor: indigo[900] }} />
            <Chip label={'PHP'} style={{ backgroundColor: indigo[900] }} />
            <Chip label={'GLSL'} style={{ backgroundColor: indigo[900] }} />
            <Chip label={'HTML5'} style={{ backgroundColor: indigo[900] }} />
            <Chip label={'CSS'} style={{ backgroundColor: indigo[900] }} />

            <Chip label={'CMake'} style={{ backgroundColor: teal[900] }} />
            <Chip label={'WebPack'} style={{ backgroundColor: teal[900] }} />
            <Chip label={'Git'} style={{ backgroundColor: teal[900] }} />

            <Chip label={'OpenGL'} style={{ backgroundColor: yellow[900] }} />
            <Chip label={'WebGL'} style={{ backgroundColor: yellow[900] }} />
            <Chip label={'Vulkan'} style={{ backgroundColor: yellow[900] }} />

            <Chip label={'Qt'} style={{ backgroundColor: pink[900] }} />
            <Chip label={'Flutter'} style={{ backgroundColor: pink[900] }} />
            <Chip label={'React'} style={{ backgroundColor: pink[900] }} />
            <Chip label={'Redux'} style={{ backgroundColor: pink[900] }} />
            <Chip label={'Jotai'} style={{ backgroundColor: pink[900] }} />
            <Chip label={'Zustand'} style={{ backgroundColor: pink[900] }} />
            <Chip label={'Mui'} style={{ backgroundColor: pink[900] }} />
            <Chip label={'LitElement'} style={{ backgroundColor: pink[900] }} />
            <Chip label={'Sass'} style={{ backgroundColor: pink[900] }} />

            <Chip label={'MySQL'} style={{ backgroundColor: blueGrey[800] }} />
            <Chip label={'PostgreSQL'} style={{ backgroundColor: blueGrey[800] }} />
            <Chip label={'DynamoDB'} style={{ backgroundColor: blueGrey[800] }} />
            <Chip label={'Redis'} style={{ backgroundColor: blueGrey[800] }} />

            <Chip label={'AWS'} style={{ backgroundColor: brown[800] }} />
            <Chip label={'S3'} style={{ backgroundColor: brown[800] }} />
            <Chip label={'RDS'} style={{ backgroundColor: brown[800] }} />
            <Chip label={'Lambda'} style={{ backgroundColor: brown[800] }} />
            <Chip label={'Aurora'} style={{ backgroundColor: brown[800] }} />
            <Chip label={'GitHub'} style={{ backgroundColor: brown[800] }} />

            <Chip label={'CoPilot'} style={{ backgroundColor: deepOrange[900] }} />
            <Chip label={'Windsurf'} style={{ backgroundColor: deepOrange[900] }} />
            <Chip label={'Ollama'} style={{ backgroundColor: deepOrange[900] }} />

            <Chip label={'Linux (Daily Driver)'} style={{ backgroundColor: purple[900] }} />
            <Chip label={'Android'} style={{ backgroundColor: purple[900] }} />
            <Chip label={'iOS'} style={{ backgroundColor: purple[900] }} />
            <Chip label={'MacOS'} style={{ backgroundColor: purple[900] }} />
            <Chip label={'Windows'} style={{ backgroundColor: purple[900] }} />
            <Chip label={'Docker'} style={{ backgroundColor: purple[900] }} />
        </Stack>
    </Paper>;
}
